<div class="bspace-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/codes" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au tableau de bord codes</a>
      <span class="crumb-current">Ma caisse</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Caisse pro</p>
        <h1>Opérations rapides</h1>
        <p class="lead">Prélèvement, dépôt, retrait et contrôle de vos soldes en un seul écran.</p>
      </div>
      <div class="pill-row">
        <span class="pill pill-strong">Solde principal : {{accountBalance | currency:sigle}}</span>
        <span class="pill">Bénéfice dépôt : {{bdepot | currency:sigle}}</span>
        <span class="pill">Bénéfice retrait : {{bretrait | currency:sigle}}</span>
      </div>
    </div>
  </div>

  <ul class="nav nav-pills glass-tabs mb-3" id="bspaceTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="achat-tab" data-bs-toggle="tab" data-bs-target="#achat" type="button"
        role="tab" aria-controls="achat" aria-selected="true">Prélèvement (achat)</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="depot-tab" data-bs-toggle="tab" data-bs-target="#depot" type="button" role="tab"
        aria-controls="depot" aria-selected="false">Dépôt</button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link" id="retrait-tab" data-bs-toggle="tab" data-bs-target="#retrait" type="button" role="tab"
        aria-controls="retrait" aria-selected="false">Retrait</button>
    </li>
    <li class="nav-item" role="presentation" *ngIf="isPatron">
      <button class="nav-link" id="controle-tab" data-bs-toggle="tab" data-bs-target="#controle" type="button"
        role="tab" aria-controls="controle" aria-selected="false">Contrôle</button>
    </li>
  </ul>

  <div class="tab-content card-glass p-3" id="bspaceTabContent">
    <div class="tab-pane fade show active" id="achat" role="tabpanel" aria-labelledby="achat-tab">
      <div class="alerts">
        <p *ngIf="succesmessage" class="alert-text success">Prélèvement effectué avec succès.</p>
        <p *ngIf="pendingValidationAchat" class="alert-text success">En attente de validation client.</p>
        <p *ngIf="error4" class="alert-text danger">Solde client insuffisant.</p>
        <p *ngIf="error3" class="alert-text danger">Code d'achat déjà utilisé.</p>
        <p *ngIf="error2" class="alert-text danger">Code d'achat introuvable.</p>
        <p *ngIf="error1" class="alert-text danger">Erreur inconnue.</p>
      </div>
      <form [formGroup]="transaction" #f2f="ngForm" (ngSubmit)="ontransaction(f2f.value)" class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Montant</label>
          <input type="number" formControlName="montant" class="form-control" placeholder="Montant">
        </div>
        <div class="col-md-6">
          <label class="form-label">Code de paiement</label>
          <input type="number" formControlName="pincode" class="form-control" placeholder="Code de paiement">
        </div>
        <div class="col-12">
          <button type="submit" [disabled]="!transaction.valid" class="btn btn-primary btn-pill">Prélever</button>
        </div>
      </form>
    </div>

    <div class="tab-pane fade" id="depot" role="tabpanel" aria-labelledby="depot-tab">
      <div class="alerts">
        <p *ngIf="errorD1" class="alert-text danger">Compte introuvable.</p>
        <p *ngIf="errorD3" class="alert-text danger">Solde insuffisant.</p>
        <p *ngIf="succesmessageDepot" class="alert-text success">Dépôt effectué avec succès.</p>
        <p *ngIf="pendingValidationDepot" class="alert-text success">En attente de validation client.</p>
        <p *ngIf="errorD4" class="alert-text danger">Opération non autorisée.</p>
      </div>
      <form [formGroup]="deposit" #f="ngForm" (ngSubmit)="makeDeposit(f.value)" class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Compte personnel</label>
          <input formControlName="compte" name="compte" type="text" class="form-control" placeholder="Numéro de compte"
            #account (blur)="checkAccount(account.value)" required>
          <small *ngIf="compte.invalid && (compte.dirty || compte.touched)" class="text-danger">Numéro invalide</small>
          <p *ngIf="confirm" class="text-success mt-1">Propriétaire : {{propritiesFirstnameLastname}}</p>
          <p *ngIf="notAccount" class="text-danger mt-1">Compte introuvable.</p>
        </div>
        <div class="col-md-6">
          <label class="form-label">Montant</label>
          <input type="number" formControlName="montant" name="montan" class="form-control"
            placeholder="Montant du dépôt">
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-primary btn-pill" [disabled]="!deposit.valid">Effectuer</button>
        </div>
      </form>
    </div>

    <div class="tab-pane fade" id="retrait" role="tabpanel" aria-labelledby="retrait-tab">
      <div class="alerts">
        <p *ngIf="errorR1" class="alert-text danger">Code de retrait introuvable.</p>
        <p *ngIf="errorR3" class="alert-text danger">Solde insuffisant.</p>
        <p *ngIf="succesmessageR" class="alert-text success">Retrait effectué avec succès.</p>
        <p *ngIf="pendingValidationRetrait" class="alert-text success">En attente de validation client.</p>
        <p *ngIf="errorR4" class="alert-text danger">Opération non autorisée.</p>
      </div>
      <form [formGroup]="retrait" #f1="ngForm" (ngSubmit)="makeRetrait(f1.value)" class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Code de retrait</label>
          <input type="text" formControlName="codeRetrait" class="form-control" placeholder="Code de retrait">
        </div>
        <div class="col-md-6">
          <label class="form-label">Montant</label>
          <input type="number" formControlName="montantRetrait" class="form-control" placeholder="Montant du retrait">
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-primary btn-pill" [disabled]="!retrait.valid">Effectuer</button>
        </div>
      </form>
    </div>

    <div class="tab-pane fade" id="controle" role="tabpanel" aria-labelledby="controle-tab" *ngIf="isPatron">
      <div class="row g-3">
        <div class="col-md-6">
          <div class="card cardlogin border-0 h-100">
            <h5 class="card-header generalbgColorV2 text-white font-weight-bolder">Solde principal</h5>
            <div class="card-body">
              <h3 class="text-white mb-0">{{accountBalance | currency:sigle}}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card cardlogin border-0 h-100">
            <h5 class="card-header generalbgColorV2 text-white font-weight-bolder">Solde initial SPAY Point</h5>
            <div class="card-body">
              <h3 class="text-white mb-0">{{depotInit | currency:sigle}}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card cardlogin border-0 h-100">
            <h5 class="card-header generalbgColorV2 text-white font-weight-bolder">Bénéfice dépôt client</h5>
            <div class="card-body">
              <h3 class="text-white mb-0">{{bdepot| currency:sigle}}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card cardlogin border-0 h-100">
            <h5 class="card-header generalbgColorV2 text-white font-weight-bolder">Bénéfice retrait client</h5>
            <div class="card-body">
              <h3 class="text-white mb-0">{{bretrait| currency:sigle}}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card cardlogin border-0 h-100">
            <h5 class="card-header generalbgColorV2 text-white font-weight-bolder">Solde achat en ligne</h5>
            <div class="card-body">
              <h3 class="text-white mb-0">{{soldeOnline| currency:sigle}}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card cardlogin border-0 h-100">
            <h5 class="card-header generalbgColorV2 text-white font-weight-bolder">Transfert vers solde principal</h5>
            <div class="card-body">
              <button type="button" class="btn btn-success btn-pill"
                (click)="TransfererVersSoldeInitial()">Transférer</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
